import gql from 'graphql-tag';

export const deleteDobMutation = gql`
  mutation deleteDob($customerId: String!) {
    deleteDob(customerId: $customerId) {
      customerId
    }
  }
`;
